import {
  Comment,
  CurrentUser,
  User,
  UsersById,
  ValueType,
} from '@energybox/react-ui-library/dist/types';
import {
  global,
  determineCommentValue,
} from '@energybox/react-ui-library/dist/utils';
import parseISO from 'date-fns/parseISO';

export const filterAndProcessComments = (
  comments: Comment[] = [],
  resourceIds: number[] = [],
  resourceValueType: ValueType,
  currentUser: CurrentUser
) => {
  if (comments && resourceIds) {
    const filteredComments = comments.filter((c) => {
      return (
        resourceIds.includes(c.resourceId) && resourceValueType === c.valueType
      );
    });
    return filteredComments.map((c) => {
      return {
        ...c,
        timestamp: parseISO(c.from).valueOf(),
        commentValue: determineCommentValue(
          c.value,
          c.valueType,
          currentUser,
          'forDisplayingInChart'
        ) as number,
        userName: c.username || global.NOT_AVAILABLE,
      };
    });
  }
  return undefined;
};
